import type { EnnismoreTheme } from '@/ui/theme';

import { morgansOriginalsTheme } from './morgansoriginals.theme';

export const morgansOriginalsParosTheme: EnnismoreTheme = {
  ...morgansOriginalsTheme,
  logoUrl: '/brands/morgansoriginals/images/morgans-paros-logo.svg',
  componentProperties: {
    ...morgansOriginalsTheme.componentProperties,
    header: {
      ...morgansOriginalsTheme.componentProperties?.header,
      logo: {
        ...morgansOriginalsTheme.componentProperties?.header?.logo,
        padding: '40px',
      },
    },
  },
};
